/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { MetaDataFromJSON, MetaDataToJSON, } from './MetaData';
import { OrganisationUserListEntryFromJSON, OrganisationUserListEntryToJSON, } from './OrganisationUserListEntry';
import { PageRequestFromJSON, PageRequestToJSON, } from './PageRequest';
/**
 * Check if a given object implements the PagedResponseOfOrganisationUserListEntry interface.
 */
export function instanceOfPagedResponseOfOrganisationUserListEntry(value) {
    var isInstance = true;
    return isInstance;
}
export function PagedResponseOfOrganisationUserListEntryFromJSON(json) {
    return PagedResponseOfOrganisationUserListEntryFromJSONTyped(json, false);
}
export function PagedResponseOfOrganisationUserListEntryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'metaData': !exists(json, 'metaData') ? undefined : MetaDataFromJSON(json['metaData']),
        'hasPrevious': !exists(json, 'hasPrevious') ? undefined : json['hasPrevious'],
        'totalElements': !exists(json, 'totalElements') ? undefined : json['totalElements'],
        'previousPage': !exists(json, 'previousPage') ? undefined : PageRequestFromJSON(json['previousPage']),
        'hasNext': !exists(json, 'hasNext') ? undefined : json['hasNext'],
        'entries': !exists(json, 'entries') ? undefined : (json['entries'].map(OrganisationUserListEntryFromJSON)),
        'size': !exists(json, 'size') ? undefined : json['size'],
        'nextPage': !exists(json, 'nextPage') ? undefined : PageRequestFromJSON(json['nextPage']),
        'page': !exists(json, 'page') ? undefined : json['page'],
        'numberOfElements': !exists(json, 'numberOfElements') ? undefined : json['numberOfElements']
    };
}
export function PagedResponseOfOrganisationUserListEntryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'metaData': MetaDataToJSON(value.metaData),
        'hasPrevious': value.hasPrevious,
        'totalElements': value.totalElements,
        'previousPage': PageRequestToJSON(value.previousPage),
        'hasNext': value.hasNext,
        'entries': value.entries === undefined ? undefined : (value.entries.map(OrganisationUserListEntryToJSON)),
        'size': value.size,
        'nextPage': PageRequestToJSON(value.nextPage),
        'page': value.page,
        'numberOfElements': value.numberOfElements
    };
}
